export const getBrowserLanguage = () => {
  const lang =
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    //@ts-ignore
    window.navigator.userLanguage ||
    //@ts-ignore
    window.navigator.browserLanguage;

  if (lang.indexOf("-") > 0) {
    const lowerLang = lang.toLowerCase();
    if (lowerLang === "zh-tw" || lowerLang === "zh-hk") {
      return "zh-TW";
    } else if (lowerLang === "zh-cn") {
      return "zh-CN";
    }

    const l2 = lang.substr(0, 2);
    return l2;
  } else if (lang == "zh") {
    return "zh-CN";
  } else {
    return lang;
  }
};
